/**
 * familyService.js — Backend API versiyonu
 * Firestore tamamen kaldırıldı. Tüm işlemler backend'e gidiyor.
 */
import { apiRequest } from "./apiClient";
import { rt } from "../i18n/runtime";
import { adminPermissions, defaultPermissions } from "../utils/permissions";
import { trackEngagementDataAdded } from "./engagementService";
import { joinFamilyWithInvite } from "./familyInviteService";

/* ── Aile oluştur ── */
export const aileOlusturService = async ({ aileAdi, user }) => {
  const data = await apiRequest("/families/create", {
    method: "POST",
    body: JSON.stringify({ name: aileAdi.trim() }),
  });
  const f = data.family;
  const createdFamilyId = f.familyId || f.id;
  trackEngagementDataAdded({ familyId: createdFamilyId, moduleKey: "family_setup", itemId: createdFamilyId, metadata: { source: "family_created" } });
  return {
    familyId  : createdFamilyId,
    familyName: f.familyName || f.name,
    familyCode: f.familyCode || f.code,
    ownerUid  : f.ownerUid || user.uid,
    rol       : "Aile Yöneticisi",
    permissions: adminPermissions,
  };
};

/* ── Aileye katıl ── */
export const aileyeKatilService = async ({ katilmaKodu, user, language }) => {
  const data = await joinFamilyWithInvite({ code: katilmaKodu, language });
  const f = data.family || {};
  const joinedFamilyId = f.familyId || f.id;
  trackEngagementDataAdded({ familyId: joinedFamilyId, moduleKey: "family_setup", itemId: joinedFamilyId, metadata: { source: "secure_family_invite" } });
  return {
    familyId  : joinedFamilyId,
    familyName: f.familyName || f.name,
    familyCode: "",
    ownerUid  : f.ownerUid || "",
    rol       : f.rol || f.role || "Aile Üyesi",
    permissions: f.permissions || defaultPermissions,
  };
};

/* ── Aileden ayrıl ── */
export const ailedenAyrilService = async ({ user, currentFamilyId }) => {
  const data = await apiRequest(`/families/${currentFamilyId}/leave`, {
    method: "POST",
  });

  if (!data.family) {
    return {
      familyId: null, familyName: "", familyCode: "", ownerUid: "",
      rol: "Aile Üyesi", permissions: defaultPermissions, remainingFamilies: [],
      familyDeleted: !!data.familyDeleted,
      deletedFamilyName: data.deletedFamilyName || "",
    };
  }

  const f = data.family;
  const nextFamilyId = f.familyId || f.id;
  return {
    familyId  : nextFamilyId,
    familyName: f.familyName || f.name || "",
    familyCode: f.familyCode || f.code || "",
    ownerUid  : f.ownerUid || "",
    rol       : f.rol || f.role || "Aile Üyesi",
    permissions: f.permissions || defaultPermissions,
    remainingFamilies: data.remainingFamilies || [],
    familyDeleted: !!data.familyDeleted,
    deletedFamilyName: data.deletedFamilyName || "",
  };
};

/* ── Borç hesabı değiştir ── */
export const borcHesabiDegistirService = async ({ familyId, yeniDeger }) => {
  await apiRequest(`/families/${familyId}`, {
    method: "PATCH",
    body: JSON.stringify({ borcHesabi: yeniDeger }),
  });
};
